import memoize from 'nano-memoize';
var references = new Map();
export default memoize(function (object, propertyName) {
  return new Promise(function (resolve) {
    if (!object[propertyName]) {
      Object.defineProperty(object, propertyName, {
        set: function set(value) {
          var properties = references.get(object) || {};
          properties[propertyName] = value;
          references.set(object, properties);
          resolve(properties[propertyName]);
        },
        get: function get() {
          var properties = references.get(object) || {};
          return properties[propertyName];
        }
      });
    } else {
      resolve(object[propertyName]);
    }
  });
});